var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.818,
    height: 20,
    viewBox: "0 0 21.818 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_8f9932d9-08a1-45d9-b465-feff3f02a5a3",
    "data-name": "8f9932d9-08a1-45d9-b465-feff3f02a5a3",
    d: "M0,7.273a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V6.364A.909.909,0,0,1,0,7.273Z",
    transform: "translate(1.437 9.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f7bba9aa-1aaf-4214-be6d-c88c51f82994",
    d: "M0,7.273a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V6.364A.909.909,0,0,1,0,7.273Z",
    transform: "translate(1.437 -0.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_188746c7-c550-4141-b41c-23c14c32d2d7",
    "data-name": "188746c7-c550-4141-b41c-23c14c32d2d7",
    d: "M0,9.091a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V8.182A.909.909,0,0,1,0,9.091Z",
    transform: "translate(8.71 7.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_68025c35-dd7b-467f-b687-78feb40bce7e",
    "data-name": "68025c35-dd7b-467f-b687-78feb40bce7e",
    d: "M0,5.455a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V4.545A.909.909,0,0,1,0,5.455Z",
    transform: "translate(8.71 -0.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fb5118fe-028e-414c-b349-7a4eb68086e4",
    d: "M0,5.455a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V4.545A.909.909,0,0,1,0,5.455Z",
    transform: "translate(15.983 11.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "de14dd12-6864-4326-9e82-33405ee32140",
    d: "M0,9.091a.909.909,0,0,1-.909-.909V0A.909.909,0,0,1,0-.909.909.909,0,0,1,.909,0V8.182A.909.909,0,0,1,0,9.091Z",
    transform: "translate(15.983 -0.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_073d82b0-7b01-408a-92e0-aa618d747103",
    "data-name": "073d82b0-7b01-408a-92e0-aa618d747103",
    d: "M5.455.909H0A.909.909,0,0,1-.909,0,.909.909,0,0,1,0-.909H5.455A.909.909,0,0,1,6.364,0,.909.909,0,0,1,5.455.909Z",
    transform: "translate(-1.29 9.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d68a102d-ff66-426f-99b1-1017101f4875",
    d: "M5.455.909H0A.909.909,0,0,1-.909,0,.909.909,0,0,1,0-.909H5.455A.909.909,0,0,1,6.364,0,.909.909,0,0,1,5.455.909Z",
    transform: "translate(5.983 3.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab1cb61b-ec24-4a8d-b95e-c9352a30e4d2",
    d: "M5.455.909H0A.909.909,0,0,1-.909,0,.909.909,0,0,1,0-.909H5.455A.909.909,0,0,1,6.364,0,.909.909,0,0,1,5.455.909Z",
    transform: "translate(13.255 11.137)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic_filter.29afbdf6856e3ca97caf820d8f1337ca.svg";
export { ForwardRef as ReactComponent };